export default __webpack_public_path__ + "static/media/Medical-Assistance-Globally.9550a38a.png";